import baseService from '@common/services/base.service';
import store from '@common/store/store';

const rpRoute = window.api_routes.smarAPD_Reports_Domain;
const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const fileManagerRoute = window.api_routes.smarAPD_FileManager_Domain;

let http = baseService(store, rpRoute);
let http2 = baseService(store, tbRoute);
let httpReportWithOutException = baseService(store, rpRoute, baseService.Timeout, false);

const apiDef = {
  moduloEmissaoRelatorio() {
    return http.get('smarapdreportmodule/modulesforgeneration/?Sistema=21');
  },

  relatorioSuggestion(parameters) {
    var moduloId = parameters.moduloId;
    var componenteUrl = parameters.componenteUrl;

    return http.get('smarapdreport/suggestionReportEmission', {
      params: {
        moduloId,
        parameters,
        componenteUrl,
      },
      noLoading: true,
    });
  },

  getParametros(reportId) {
    return http.get(`smarapdreportparameter/parameters?reportId=${reportId}`);
  },

  getHasReports(url) {
    return httpReportWithOutException.get(`smarapdreportcomponent/componenthasreport?url=${url}`);
  },

  postGerarRelatorioSelecao(codigoRelatorio, idSelecao) {
    return http2.post('report/generatereportbyidselecao', {
      CodigoRelatorio: codigoRelatorio,
      IdSelecao: idSelecao,
    });
  },

  postGerarRelatorio(data) {
    const { codigoRelatorio, parameters, isBackground, modulo, formato } = data;
    const request = isBackground ? 'report/executebackground' : 'report/execute';

    return http.post(request, {
      Async: false,
      ExportType: formato,
      Codigo: codigoRelatorio,
      Parameters: parameters,
      ViewInBrowser: true,
      IsBackground: isBackground,
      Modulo: modulo,
    });
  },
};

export default apiDef;
